import {
  SeriesItemViewOptions,
  SeriesViewOptions,
  VisualisationOrientation,
  VisualisationViewOptions,
} from '@/explore/types';

const getSeriesOptions = (options: VisualisationViewOptions): SeriesViewOptions =>
  options.series ?? {};

export const getSeriesItemOptionsByKey = (
  visualisationOptions: VisualisationViewOptions,
  seriesKey: string,
): SeriesItemViewOptions => getSeriesOptions(visualisationOptions)[seriesKey] ?? {};

export const setVisualisationStackedOption = (
  visualisationOptions: VisualisationViewOptions,
  stacked: boolean,
): VisualisationViewOptions => ({
  ...visualisationOptions,
  stacked,
});

export const setVisualisationShowTotalsOption = (
  visualisationOptions: VisualisationViewOptions,
  showTotals: boolean,
): VisualisationViewOptions => ({
  ...visualisationOptions,
  showTotals,
});

export const setVisualisationOrientationOption = (
  visualisationOptions: VisualisationViewOptions,
  orientation: VisualisationOrientation,
): VisualisationViewOptions => ({
  ...visualisationOptions,
  orientation,
});
